/* eslint-disable react-hooks/exhaustive-deps */
import { useAmplitude } from "lib/amplitude/Amplitude";
import useSelfie from "lib/hooks/useSelfie";
import type { ReactElement } from "react";
import { memo, useEffect } from "react";

interface AmplitudeIdentifyProps {
  children?: ReactElement;
}

function AmplitudeIdentify({ children }: AmplitudeIdentifyProps) {
  const amplitude = useAmplitude();
  const selfie = useSelfie();

  useEffect(() => {
    if (!selfie || amplitude.getUserId()) {
      return;
    }

    amplitude.setUserId(selfie._id);
    amplitude.setUserProperties({
      _id: selfie._id,
      email: selfie.email,
      firstName: selfie.firstName,
      lastName: selfie.lastName,
      fullName: selfie.fullName,
      // eslint-disable-next-line no-nested-ternary
      plan: selfie.isBlack ? "BLACK" : selfie.isPremium ? "PREMIUM" : "FREE",
    });
  }, [selfie?._id]);

  return children || null;
}

export default memo(AmplitudeIdentify);
